import { Icon, IconProps } from "../";

export const LocationOnIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M100,714 C96.13,714 93,717.13 93,721 C93,725.17 97.42,730.92 99.24,733.11 C99.64,733.59 100.37,733.59 100.77,733.11 C102.58,730.92 107,725.17 107,721 C107,717.13 103.87,714 100,714 Z M100,723.5 C98.62,723.5 97.5,722.38 97.5,721 C97.5,719.62 98.62,718.5 100,718.5 C101.38,718.5 102.5,719.62 102.5,721 C102.5,722.38 101.38,723.5 100,723.5 Z"
        transform="translate(-88 -712)"
      />
    </Icon>
  );
};
